// Components
import { PerformanceSubjectScreen } from "./performance-subject.component";

export default PerformanceSubjectScreen;
